export { default } from './DevicesList';
